module.exports = __webpack_public_path__ + "img/things6.dbc0b2fe.png";